export default "__VITE_ASSET__DU$i2lX___"